import Api from "../axios"

export const getRewards = async(pageNumber,pageSize)=>{
    return await Api.get(`Global/Rewards?pageNumber=${pageNumber}&pageSize=${pageSize}`)
}